import {ComponentService} from "./service/component";
import {Application} from "./application/application";
import {ArticlesComponent} from "./components/articles";

require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {

    let components = new ComponentService();
    components.addComponent('.js-articles', ArticlesComponent, 'ArticlesComponent');
    new Application(components);

}))(jQuery);
